import $ from 'jquery';
import whatInput from 'what-input';
import * as bootstrap from 'bootstrap';
import AOS from 'aos';

import { MyPN } from './esm/pin.esm.js';
import { MyTG } from './esm/toggle.esm.js';
import { MySD } from './esm/send.esm.js';
import { MyHD } from './esm/header.esm.js';
import { MyDR } from './esm/drop.esm.js';
import { MyMQ } from './esm/marquee.esm.js';
import { MyGM } from './esm/maps.esm.js';
import { MyIF } from './esm/viewer.esm.js';
import { MySW } from './esm/swiper.esm.js';
import { MyYT } from './esm/youtube.esm.js';
import { MyVm } from './esm/vimeo.esm.js';
import { MyHR } from './esm/hero.esm.js';

import { initLoading } from './helpers/spinner.js';
import { initModernizr, isTouchDevice } from './helpers/modernizr.js';
import { initClose } from './helpers/closeFrame.js';
import { initBreakpointDetection , getCurrentBreakpoint } from './helpers/breakpoints.js';
import './helpers/resize.js';
import { initSplitText } from './helpers/splitText.js';
import { MyCount } from './helpers/count.js';
import { initLangDropdown } from './helpers/dropdown.js';
import { initBambooObserver } from './helpers/bambooObserver.js';
import { initScrollTopButton } from './helpers/scrollTop.js';
import { initOurTeamScroll } from './helpers/ourTeamScroll.js';
import initLoadMoreProjects from './helpers/button.js';

initClose( );
initModernizr( );
initBreakpointDetection( );
initSplitText( );
initLoading( );
initLoadMoreProjects();

document.addEventListener( 'DOMContentLoaded' , ( event ) => {
  AOS.init( );
  MyPN.initAll( );
  MyTG.initAll( );
  MySD.initAll( );
  MyHD.initAll( );
  MyDR.initAll( );
  MyMQ.initAll( );
  MyGM.initAll( );
  MyIF.initAll( );
  MySW.initAll( );
  MyYT.initAll( );
  MyVm.initAll( );
  MyHR.initAll( );
  MyCount.init( );
  initOurTeamScroll();
  initBambooObserver();
  initLangDropdown();
  initScrollTopButton();
  setTimeout( ( ) => AOS.refresh( ), 100 );

  window.addEventListener( 'breakpointChange' , ( event ) => {
    AOS.refresh( );
    console.log( '===> breakpointChange => ' , event );
  });
  $( '.collapse' ).on( 'shown.bs.collapse' , ( event ) => {
    AOS.refresh( );
    console.log( '===> shown.bs.collapse => ' , event );
  });
  $( '.collapse' ).on( 'hidden.bs.collapse' , ( event ) => {
    AOS.refresh( );
    console.log( '===> hidden.bs.collapse => ' , event );
  });
  window.addEventListener( 'onResizeInit' , ( event ) => {
    console.log( '===> onResizeInit => ' , event );
  });
  window.addEventListener( 'onResizeEnd' , ( event ) => {
    AOS.refresh( );
    console.log( '===> onResizeEnd => ' , event );
  });
});
